module.exports = __webpack_public_path__ + "static/media/icon_add_student.9757a2d7.svg";